import { useMutation } from '@tanstack/react-query'
import { type FormEvent, useState } from 'react'
import { resetPassword } from './api'

type Props = {
  onDone: () => void
}

/**
 * Новый пароль по ссылке из письма.
 *
 * Токен и почта приходят в адресе — руками их вводить не просят: человек
 * сюда попал по ссылке, и всё, что от него нужно, это новый пароль.
 */
export function ResetScreen({ onDone }: Props) {
  const params = new URLSearchParams(window.location.search)
  const token = params.get('token') ?? ''
  const email = params.get('email') ?? ''

  const [password, setPassword] = useState('')
  const [repeat, setRepeat] = useState('')

  const reset = useMutation({
    mutationFn: () => resetPassword({ token, email, password, password_confirmation: repeat }),
  })

  const submit = (event: FormEvent) => {
    event.preventDefault()
    reset.mutate()
  }

  return (
    <div className="lobby">
      <div className="hero">
        <h2 className="hero__title">Новый пароль</h2>
      </div>

      <div className="card">
        {token === '' || email === '' ? (
          <p className="empty">ссылка неполная — откройте её из письма целиком</p>
        ) : reset.isSuccess ? (
          <>
            <p className="muted">{reset.data}</p>
            <button className="primary wide" type="button" onClick={onDone}>
              Войти
            </button>
          </>
        ) : (
          <form className="form" onSubmit={submit}>
            <input
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="Новый пароль"
              type="password"
              autoComplete="new-password"
              maxLength={72}
            />
            <input
              value={repeat}
              onChange={(event) => setRepeat(event.target.value)}
              placeholder="Пароль ещё раз"
              type="password"
              autoComplete="new-password"
              maxLength={72}
            />
            <button className="primary wide" type="submit" disabled={reset.isPending}>
              Сохранить
            </button>

            {reset.isError && <p className="banner banner--error">{errorText(reset.error)}</p>}
          </form>
        )}
      </div>
    </div>
  )
}

/** Текст ошибки от сервера: он объясняет, что именно не так. */
export function errorText(error: unknown): string {
  const response = (
    error as { response?: { data?: { message?: string; errors?: Record<string, string[]> } } }
  ).response

  return (
    Object.values(response?.data?.errors ?? {})[0]?.[0] ??
    response?.data?.message ??
    'не получилось — попробуйте ещё раз'
  )
}
